import './report-row.styl'
import React from 'react'
import { Row, Col } from 'react-bootstrap'


class Component extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    let { report, click, active } = this.props

    if (typeof click !== 'function') {
      click = () => {}
    }

    let classNames = 'report-row'

    if (active) {
      classNames += ' active'
    }

    return (
      <div className={classNames} onClick={ (e) => { click(e) } }>
        <Row>
          <Col xs={9}>{ report.name || report.createdAt }</Col>
          <Col xs={3} className="align-right"><i className="fa fa-chevron-right" /></Col>
        </Row>
      </div>
    )
  }
}

export default Component



// WEBPACK FOOTER //
// ./components/Reports/report-row.js